import { Link } from "react-router-dom";
import SEO from "@/components/feature/SEO";
import VideoCard from "@/components/base/VideoCard";
import { categories, videos } from "@/mocks/videos";

const hotVideos = videos.filter((v) => v.isHot);
const newVideos = videos.filter((v) => v.isNew);
const rankedVideos = [...videos].sort((a, b) => b.views - a.views).slice(0, 10);

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "久久视频",
  url: typeof window !== "undefined" ? window.location.origin : "",
  description: "久久视频网聚合香蕉视频、红桃视频等热门平台资源，免费在线看最新电影、热播电视剧、美剧韩剧全集。",
  sameAs: [],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "久久视频",
  url: typeof window !== "undefined" ? window.location.origin : "",
  description: "久久视频网聚合香蕉视频、红桃视频等热门平台资源，免费在线看最新电影、热播电视剧、美剧韩剧全集，高清不缓冲。",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${typeof window !== "undefined" ? window.location.origin : ""}/search?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "久久视频-香蕉视频与红桃视频最新电影热播剧 | 免费高清在线观看电视剧全集",
  description: "久久视频网聚合香蕉视频、红桃视频等热门平台资源，免费在线看最新电影、热播电视剧、美剧韩剧全集，高清不缓冲，追剧看电影首选。",
  url: typeof window !== "undefined" ? window.location.href : "",
};

export default function Home() {
  return (
    <>
      <SEO
        title="久久视频-香蕉视频与红桃视频最新电影热播剧 | 免费高清在线观看电视剧全集"
        description="久久视频网聚合香蕉视频、红桃视频等热门平台资源，免费在线看最新电影、热播电视剧、美剧韩剧全集，高清不缓冲，追剧看电影首选。"
        keywords="久久视频,香蕉视频,红桃视频,91视频,最新电影,热播剧,高清在线观看,免费电视剧,美剧,韩剧,电影大全"
        ogImage="https://readdy.ai/api/search-image?query=A%20modern%20video%20streaming%20platform%20homepage%20hero%20image%2C%20cinematic%20style%2C%20warm%20golden%20and%20red%20accents%2C%20movie%20film%20reel%20motif%2C%20clean%20and%20modern%20design%2C%20professional%20photography%20style&width=1200&height=630&seq=home-og-image&orientation=landscape"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([organizationSchema, websiteSchema, webPageSchema]) }}
      />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20background%20with%20warm%20golden%20orange%20and%20deep%20red%20gradient%20tones%2C%20subtle%20film%20grain%20texture%2C%20soft%20bokeh%20lights%2C%20elegant%20and%20modern%20streaming%20platform%20hero%20backdrop%2C%20dark%20rich%20atmosphere%2C%20no%20text%2C%20clean%20minimal%20composition&width=1920&height=1080&seq=home-hero-bg&orientation=landscape"
            alt="久久视频 - 免费高清在线观看"
            title="久久视频 - 最新电影热播剧免费在线观看"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white text-center font-heading mb-4 max-w-4xl">
              久久视频 - 免费高清在线观看电视剧全集
            </h1>
            <p className="text-base md:text-lg text-white/80 text-center max-w-2xl mb-8">
              聚合香蕉视频、红桃视频、91视频等热门平台资源，最新电影、热播电视剧、美剧韩剧一站尽享
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-xl">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="搜索你想看的电影、电视剧..."
                  className="w-full pl-12 pr-4 py-3.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white placeholder:text-white/50 text-sm focus:outline-none focus:bg-white/25 focus:border-white/40 transition-all"
                />
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/60 text-lg"></i>
              </div>
              <button className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer">
                立即搜索
              </button>
            </div>
            <div className="flex items-center gap-4 mt-8">
              {["香蕉视频", "红桃视频", "91视频"].map((p) => (
                <span key={p} className="text-white/60 text-xs bg-white/10 px-3 py-1.5 rounded-full backdrop-blur-sm whitespace-nowrap">
                  {p}
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="bg-primary-500 text-background-50 py-4">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
              <div>
                <p className="text-2xl md:text-3xl font-bold font-heading">100,000+</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">视频资源</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold font-heading">30+</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">合作平台</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold font-heading">5000万+</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">活跃用户</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold font-heading">99.9%</p>
                <p className="text-xs md:text-sm text-background-50/80 mt-1">播放成功率</p>
              </div>
            </div>
          </div>
        </section>

        {/* Category Grid */}
        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">视频分类</h2>
              <p className="text-sm text-foreground-500 mt-1">按类别快速找到你想看的内容</p>
            </div>
            <Link to="/category/latest-movies" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1">
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg p-4 text-center transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer"
              >
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-400 mt-1">{cat.count}部</p>
              </Link>
            ))}
          </div>
        </section>

        {/* Hot Videos Section */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                  <i className="ri-fire-line text-accent-500 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">大家都在看的热门内容</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop="">
              {hotVideos.slice(0, 8).map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* Hot Ranking + New Videos */}
        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Ranking */}
            <div className="lg:col-span-1">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                <h3 className="text-lg font-bold text-foreground-900 font-heading mb-4 flex items-center gap-2">
                  <i className="ri-medal-line text-accent-500"></i>
                  热门排行榜
                </h3>
                <div className="space-y-0">
                  {rankedVideos.map((video, index) => (
                    <Link
                      key={video.id}
                      to={`/article/${video.id}`}
                      className="flex items-center gap-3 py-3 border-b border-background-100 last:border-b-0 cursor-pointer group hover:bg-background-50 transition-colors -mx-2 px-2 rounded"
                    >
                      <span className={`w-6 h-6 flex items-center justify-center rounded text-xs font-bold shrink-0 ${
                        index < 3
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-200 text-foreground-500"
                      }`}>
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                          {video.title}
                        </h4>
                        <div className="flex items-center gap-2 mt-0.5 text-xs text-foreground-400">
                          <span>{video.category}</span>
                          <span className="flex items-center gap-1">
                            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                            {video.rating}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Latest Updates */}
            <div className="lg:col-span-2">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                    <i className="ri-sparkling-line text-primary-500 mr-2"></i>
                    最新上线
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">刚刚更新的热门内容</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-product-shop="">
                {newVideos.slice(0, 6).map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Platform Partners */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">合作平台</h2>
            <p className="text-sm text-foreground-500 mb-8">聚合多家优质视频平台，一站式畅享海量内容</p>
            <div className="flex flex-wrap items-center justify-center gap-6">
              {[
                { name: "香蕉视频", icon: "ri-movie-line" },
                { name: "红桃视频", icon: "ri-heart-line" },
                { name: "91视频", icon: "ri-play-circle-line" },
              ].map((p) => (
                <div
                  key={p.name}
                  className="bg-background-50 border border-background-200/70 rounded-lg px-8 py-6 cursor-pointer hover:border-primary-300 transition-all duration-300"
                >
                  <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${p.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-800">{p.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20background%20with%20soft%20golden%20and%20amber%20gradient%2C%20cinematic%20bokeh%20effect%2C%20elegant%20abstract%20texture%2C%20luxurious%20feel%2C%20dark%20rich%20edges%2C%20centered%20warm%20glow&width=1920&height=600&seq=home-cta-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/70"></div>
          <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">开始你的观影之旅</h2>
            <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
              10万+影视资源，每日更新，完全免费。现在就加入久久视频，发现你的下一部最爱。
            </p>
            <Link
              to="/category/latest-movies"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即探索 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}